import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout-Route fuer /inbox. Reine Wrapper-Komponente — Listen-Inhalt liegt in
 * inbox.index.tsx, Detail-Routen (inbox.$id.tsx) werden ueber den Outlet hier
 * gerendert.
 */
export const Route = createFileRoute('/inbox')({
  component: InboxLayout,
});

function InboxLayout() {
  return <Outlet />;
}
